interface IResult<T> {
  promise: Promise<T>;
  abort: () => void;
}
export type TLoadThumbnail<T> = (src: string) => IResult<T>;

export enum ImageLoadError {
  ImageSrcIsNull = 'Image src is null',
  CannotLoadImage = 'Cannot load image',
  ImageLoadCancelled = 'Image load cancelled',
}

export enum VideoLoadError {
  VideoSrcIsNull = 'Video src is null',
  CannotLoadVideo = 'Cannot load video',
  VideoLoadCancelled = 'Video load cancelled',
}

export const loadImage: TLoadThumbnail<HTMLImageElement> = (src: string) => {
  const result = { promise: null, abort: () => {} };

  result.promise = new Promise<HTMLImageElement>((resolve, reject) => {
    if (!src) {
      reject(new Error(ImageLoadError.ImageSrcIsNull));
      return;
    }

    const image = new Image();
    image.src = src;

    image.onload = () => {
      result.abort = () => {};
      resolve(image);
    };

    image.onerror = () => {
      result.abort = () => {};
      reject(new Error(ImageLoadError.CannotLoadImage));
    };

    result.abort = () => {
      result.abort = () => {};
      image.src = '';
      reject(new Error(ImageLoadError.ImageLoadCancelled));
    };
  });

  return result;
};

export const loadVideo: TLoadThumbnail<HTMLVideoElement> = (src) => {
  const result = { promise: null, abort: () => {} };

  result.promise = new Promise<HTMLVideoElement>((resolve, reject) => {
    if (!src) {
      reject(new Error(VideoLoadError.VideoSrcIsNull));
      return;
    }

    const video = document.createElement('video');
    video.src = src;

    video.onloadeddata = () => {
      result.abort = () => {};
      resolve(video);
    };

    video.onerror = () => {
      result.abort = () => {};
      reject(new Error(VideoLoadError.CannotLoadVideo));
    };

    result.abort = () => {
      video.src = '';
      reject(new Error(VideoLoadError.VideoLoadCancelled));
    };
  });

  return result;
};
